/**
 * Thin wrapper around NEXT_PUBLIC_ENV so that tests can mock it.
 * next/jest inlines process.env.NEXT_PUBLIC_* at transform time, so dynamically
 * setting process.env.NEXT_PUBLIC_ENV in a test has no effect on compiled code.
 * Route through this module so tests can do:
 *   jest.mock("~/utils/envConfig", () => ({ isProductionEnv: jest.fn(() => true) }))
 */
export const isProductionEnv = (): boolean => process.env.NEXT_PUBLIC_ENV?.toUpperCase() === 'PROD';
